import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { displayPCSButton, hasPCSAttachment } from '../../flags/pcs.flag';
import { openPCSModal } from '../PhysicianCertificationStatement/redux/openPCSModal';
import EPCSButton from './EPCSButton';

const EPCSButtonContainer = ({ isVisible, isDisabled, tooltip, openPCSModal, ...props }) => {
  const handleLaunchPCS = () => {
    openPCSModal({ open: true, context: 'epcs' });
  };

  if (!isVisible) {
    return null;
  }

  return <EPCSButton onClick={handleLaunchPCS} disabled={isDisabled} tooltip={tooltip} {...props} />;
};

const mapStateToProps = state => {
  const isVisible = displayPCSButton(state);
  const isDisabled = hasPCSAttachment(state);

  const tooltip = isDisabled ? 'A PCS form is already attached. You can view it in the attachments section.' : '';

  return {
    isVisible,
    isDisabled,
    tooltip,
  };
};

EPCSButtonContainer.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  tooltip: PropTypes.string,
  openPCSModal: PropTypes.func.isRequired,
};

EPCSButtonContainer.defaultProps = {
  tooltip: '',
};

export default connect(mapStateToProps, { openPCSModal })(EPCSButtonContainer);
